// CRA inlines REACT_APP_* at build time. CI also injects window.__RUNTIME_API_BASE__ into build/index.html
// so the gateway URL is correct even if an old service worker served stale JS without the inlined env.
function getApiBase() {
  if (typeof window !== "undefined" && window.__RUNTIME_API_BASE__) {
    const fromWindow = String(window.__RUNTIME_API_BASE__).trim();
    if (fromWindow) {
      return fromWindow.replace(/\/$/, "");
    }
  }
  return (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
}

/**
 * Dev: paths stay `/api/...` and webpack dev server proxies to the backend.
 * CI: GitHub repository variable REACT_APP_API_BASE_URL → .env.production.local before npm run build (see azure-deploy.yml).
 */
export function resolveApiRequest(url) {
  if (!url || typeof url !== "string") {
    return { baseURL: undefined, url };
  }
  const API_BASE = getApiBase();
  const hasApiPrefix = /^\/?api(\/|$)/.test(url);
  if (!API_BASE || !hasApiPrefix) {
    return { baseURL: undefined, url };
  }
  return {
    baseURL: API_BASE,
    url: url.replace(/^\/?api(\/|$)/, "/"),
  };
}

/** Full URL for browser-only uses (img src, etc.) that do not go through axios. */
export function resolvePublicApiUrl(path) {
  if (!path || typeof path !== "string") {
    return path;
  }
  const { baseURL, url } = resolveApiRequest(path);
  if (!baseURL) {
    return path;
  }
  return `${baseURL}${url.startsWith("/") ? url : `/${url}`}`;
}
